import { z } from "zod";

export const tradeCodeSchema = z.enum([
  "flooring",
  "drywall",
  "tiling",
  "removal",
  "painting",
  "deck",
  "fence",
  "plumbing",
  "electrical",
  "windows",
  "doors",
  "trim",
]);
export type TradeCode = z.infer<typeof tradeCodeSchema>;
